import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FundingBar } from '../../../components/delivery/widgets/FundingBar';
import { FinancialHealthTab } from './FinancialHealthTab';
export function FinancialTab({ programId }) {
    return /*#__PURE__*/ _jsxs("div", {
        className: "space-y-6",
        children: [
            /*#__PURE__*/ _jsx(FundingBar, {
                programId: programId
            }),
            /*#__PURE__*/ _jsx(FinancialHealthTab, {
                programId: programId
            })
        ]
    });
}
